import React from 'react';
import { useNavigate } from 'react-router-dom';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import Layout from './Layout';
import './CustomersLanding.css';

const OPTIONS = [
  {
    key: 'import',
    name: 'Import Customers',
    Icon: UploadFileOutlinedIcon,
    route: '/admin/customers/import',
    description: 'Import customers from Excel',
  },
  {
    key: 'list',
    name: 'Customer List',
    Icon: ListAltOutlinedIcon,
    route: '/admin/customers/list',
    description: 'View all imported customers',
  },
];

const CustomersLanding = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="customers-landing">
        <header className="customers-landing-header">
          <h1 className="home-menu-title">Customers</h1>
          <p className="home-menu-intro customers-landing-intro">
            Administration: import customer master data and view the complete customer list.
          </p>
        </header>
        <div className="customers-options-row" role="region" aria-label="Customer actions">
          {OPTIONS.map((opt) => (
            <button
              key={opt.key}
              type="button"
              className="menu-card menu-card-dark menu-card-home customers-option-card"
              onClick={() => navigate(opt.route)}
            >
              <span className="menu-card-icon-wrap" aria-hidden>
                <opt.Icon className="menu-card-mui-icon" />
              </span>
              <span className="customers-card-text">
                <span className="menu-card-label">{opt.name}</span>
                <span className="customers-card-desc">{opt.description}</span>
              </span>
            </button>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default CustomersLanding;
